import { isoDateFormat } from "../../utils/isoDateFormat.js";
import { DateTime } from "../../utils/luxon.js";
import type { OrderProductDetail } from "../OrderProductDetail.js";
import type { ProductForCustomer } from "../Product.js";

export function getProductsWithNotPermittedPickUpDateAtDate<Item extends ProductForCustomer | OrderProductDetail>(
	date: string,
	products: Item[],
): Item[] {
	const deliveryDate = DateTime.fromISO(date).toFormat(isoDateFormat);
	return products.filter(
		({ enablePermittedPickUpDates, permittedPickUpDates }: Item) =>
			enablePermittedPickUpDates && !permittedPickUpDates.includes(deliveryDate),
	);
}
